/* =========================================================
   INKSOFT PRODUCT PAGE MODULE
   Page-specific renderer for templates/page.inksoft-product.liquid
========================================================= */

window.InksoftPOC = window.InksoftPOC || {};

window.InksoftPOC.productPage = (function () {
  const core = window.InksoftPOC.core;

  const storefrontDisplayDefaults = {
    productGrid: { showSku: false, showBrand: false },
    productDetail: { showSku: false, showBrand: false }
  };

  let storefrontDisplaySettings = storefrontDisplayDefaults;

  function installStorefrontDisplayStyle() {
    if (document.getElementById('ua-product-detail-display-style')) return;

    const style = document.createElement('style');
    style.id = 'ua-product-detail-display-style';
    style.textContent =
      '.ua-product-detail-sku,.ua-product-detail-brand{display:none}' +
      '.ua-show-detail-sku .ua-product-detail-sku{display:block}' +
      '.ua-show-detail-brand .ua-product-detail-brand{display:block}';

    document.head.appendChild(style);
  }

  function applyStorefrontDisplaySettings(settings) {
    storefrontDisplaySettings = settings || storefrontDisplayDefaults;

    const detailSettings = storefrontDisplaySettings.productDetail || {};

    document.documentElement.classList.toggle(
      'ua-show-detail-sku',
      detailSettings.showSku === true
    );

    document.documentElement.classList.toggle(
      'ua-show-detail-brand',
      detailSettings.showBrand === true
    );
  }

  async function loadStorefrontDisplaySettings() {
    installStorefrontDisplayStyle();
    applyStorefrontDisplaySettings(storefrontDisplayDefaults);

    try {
      const response = await fetch('/apps/inksoft/storefront/display-settings', {
        method: 'GET',
        cache: 'no-store',
        credentials: 'same-origin'
      });

      if (!response.ok) throw new Error('HTTP ' + response.status);

      const payload = await response.json();
      applyStorefrontDisplaySettings(
        payload && payload.data ? payload.data : storefrontDisplayDefaults
      );
    } catch (_error) {
      applyStorefrontDisplaySettings(storefrontDisplayDefaults);
    }
  }

  let state = {
    product: null,
    currentStyleId: '',
    currentImages: [],
    currentImageIndex: 0,
    activeTab: 'description',
    selectedDesign: null,
    selectedDesignConfirmedByUser: false,
    selectedDesignRestoredFromUrl: false,
    designImageFailed: false,
    zoomLocked: false,
    lastLaunchContext: null,
    preparedDesignLaunch: null,
    preparedDesignLaunchPromise: null,
    blankStylePrewarmTimer: null,
    blankStylePrewarmIframe: null,
    blankStylePrewarmKey: '',
    blankStylePrewarmUrl: '',
    blankStylePrewarmStartedAt: 0,
    blankStylePrewarmLoadedAt: 0
  };

  function getRoot() {
    return document.getElementById('inksoft-product-root');
  }

  function setStatus(message, type) {
    const el = document.getElementById('inksoft-product-status');
    if (!el) return;

    el.className = 'inksoft-product-status ' + (
      type === 'success'
        ? 'inksoft-product-status--success'
        : type === 'error'
        ? 'inksoft-product-status--error'
        : 'inksoft-product-status--info'
    );

    el.textContent = message;
  }

  const utils = window.InksoftPOC.productUtils || {};

  const asArray = typeof utils.asArray === 'function'
    ? utils.asArray
    : function (value) {
        return Array.isArray(value) ? value : [];
      };

  const asString = typeof utils.asString === 'function'
    ? utils.asString
    : function (value) {
        return value == null ? '' : String(value).trim();
      };

  const firstNonEmpty = typeof utils.firstNonEmpty === 'function'
    ? utils.firstNonEmpty
    : function () {
        for (let i = 0; i < arguments.length; i += 1) {
          const value = asString(arguments[i]);
          if (value) return value;
        }
        return '';
      };

  const normalizeInksoftUrl = typeof utils.normalizeInksoftUrl === 'function'
    ? utils.normalizeInksoftUrl
    : function (url) {
        let value = asString(url);
        if (!value) return '';

        value = value.replace(/\/Unisource_Apparel\/Unisource_Apparel\//g, '/Unisource_Apparel/');

        if (/^https?:\/\//i.test(value)) return value;
        if (value.indexOf('/Unisource_Apparel/') === 0) return 'https://shop.unisourceapparel.com' + value;
        if (value.indexOf('/images/') === 0) return 'https://shop.unisourceapparel.com/Unisource_Apparel' + value;
        if (value.indexOf('/JITImage/') === 0) return 'https://shop.unisourceapparel.com/Unisource_Apparel' + value;

        return value;
      };

  const isPdfUrl = typeof utils.isPdfUrl === 'function'
    ? utils.isPdfUrl
    : function (url) {
        return /\.pdf(?:\?|#|$)/i.test(asString(url));
      };

  function buildOriginalProductImageUrl(url) {
    const value = normalizeInksoftUrl(url);

    if (!value) return '';
    if (!/\/images\/products\//i.test(value)) return value;
    if (/\/Original\.png(?:\?|#|$)/i.test(value)) return value;

    return value.replace(
      /\/(?:50|75|100|150|200|250|300|400|480|500|600|800|1000|1200)\.png([?#].*)?$/i,
      '/Original.png$1'
    );
  }

  function getHighResolutionProductImageUrl(image) {
    if (!image) return '';

    return normalizeInksoftUrl(firstNonEmpty(
      image.originalUrl,
      image.OriginalUrl,
      image.zoomUrl,
      image.ZoomUrl,
      buildOriginalProductImageUrl(image.imageUrl),
      image.imageUrl,
      image.thumbnailUrl
    ));
  }

  const isImageUrl = typeof utils.isImageUrl === 'function'
    ? utils.isImageUrl
    : function (url) {
        return /\.(png|jpe?g|gif|webp|svg)(?:\?|#|$)/i.test(asString(url));
      };

  const isJitImageUrl = typeof utils.isJitImageUrl === 'function'
    ? utils.isJitImageUrl
    : function (url) {
        return /\/JITImage\//i.test(asString(url));
      };

  const sanitizeHex = typeof utils.sanitizeHex === 'function'
    ? utils.sanitizeHex
    : function (value) {
        const raw = asString(value).replace(/^#/, '').trim();

        if (/^[A-Fa-f0-9]{6}$/.test(raw)) return raw.toUpperCase();

        if (/^[A-Fa-f0-9]{3}$/.test(raw)) {
          return raw
            .split('')
            .map(function (c) {
              return c + c;
            })
            .join('')
            .toUpperCase();
        }

        return '';
      };

  function isTouchDevice() {
    return (
      ('ontouchstart' in window) ||
      (navigator.maxTouchPoints > 0) ||
      (window.matchMedia && window.matchMedia('(pointer: coarse)').matches)
    );
  }

  function getStyles(product) {
    return []
      .concat(asArray(product && product.styles))
      .concat(asArray(product && product.Styles))
      .concat(asArray(product && product.baseStyles))
      .concat(asArray(product && product.BaseStyles))
      .concat(asArray(product && product.productStyles))
      .concat(asArray(product && product.ProductStyles));
  }

  function getStyleId(style, fallbackIndex) {
    const value = firstNonEmpty(
      style && style.id,
      style && style.ID,
      style && style.Id,
      style && style.styleId,
      style && style.StyleId,
      style && style.StyleID,
      style && style.productStyleId,
      style && style.ProductStyleId,
      style && style.ProductStyleID,
      style && style.BaseStyleId,
      style && style.BaseStyleID
    );

    if (value) return value;
    return String(fallbackIndex == null ? '' : fallbackIndex);
  }

  function getStyleName(style) {
    return firstNonEmpty(
      style && style.name,
      style && style.Name,
      style && style.displayName,
      style && style.DisplayName,
      style && style.colorName,
      style && style.ColorName,
      style && style.description,
      style && style.Description,
      style && style.label,
      style && style.Label,
      'Style'
    );
  }

  function getDefaultStyle(styles) {
    if (!Array.isArray(styles) || !styles.length) return null;

    for (let i = 0; i < styles.length; i += 1) {
      if (styles[i] && (
        styles[i].isDefault ||
        styles[i].IsDefault ||
        styles[i].default ||
        styles[i].Default
      )) {
        return styles[i];
      }
    }

    return styles[0] || null;
  }

  function getCurrentStyle() {
    const styles = getStyles(state.product);
    if (!styles.length) return null;

    const currentId = asString(state.currentStyleId);
    if (currentId) {
      for (let i = 0; i < styles.length; i += 1) {
        if (getStyleId(styles[i], i) === currentId) {
          return styles[i];
        }
      }
    }

    return getDefaultStyle(styles);
  }

  function getCurrentStyleHex() {
    const style = getCurrentStyle();
    if (!style) return '';

    const candidates = [
      style.htmlColor1,
      style.htmlColor2,
      style.HtmlColor1,
      style.HtmlColor2,
      style.hex,
      style.Hex,
      style.colorHex,
      style.ColorHex,
      style.swatchHex,
      style.SwatchHex
    ];

    for (let i = 0; i < candidates.length; i += 1) {
      const normalized = sanitizeHex(candidates[i]);
      if (normalized) return normalized;
    }

    return '';
  }

  function getStyleImages(style, product) {
    const results = [];
    const seen = {};

    const sides = []
      .concat(asArray(style && style.sides))
      .concat(asArray(style && style.Sides));

    sides.forEach(function (side) {
      const imageUrl = normalizeInksoftUrl(asString(side && (
        side.imageUrl ||
        side.ImageUrl ||
        side.url ||
        side.Url
      )));
      const thumbnailUrl = normalizeInksoftUrl(asString(side && (
        side.thumbnailUrl ||
        side.ThumbnailUrl ||
        imageUrl
      )));

      if (!imageUrl && !thumbnailUrl) return;

      const key = imageUrl || thumbnailUrl;
      if (seen[key]) return;
      seen[key] = true;

      const fullImageUrl = imageUrl || thumbnailUrl;

      results.push({
        label: [
          getStyleName(style),
          firstNonEmpty(side && side.side, side && side.Side, side && side.name, side && side.Name)
        ].filter(Boolean).join(' - ') || 'View',
        imageUrl: fullImageUrl,
        thumbnailUrl: thumbnailUrl || imageUrl,
        originalUrl: normalizeInksoftUrl(asString(
          side && (
            side.originalUrl ||
            side.OriginalUrl ||
            side.originalImageUrl ||
            side.OriginalImageUrl
          )
        )) || buildOriginalProductImageUrl(fullImageUrl),
        zoomUrl: normalizeInksoftUrl(asString(
          side && (
            side.zoomUrl ||
            side.ZoomUrl ||
            side.largeImageUrl ||
            side.LargeImageUrl
          )
        )) || buildOriginalProductImageUrl(fullImageUrl)
      });
    });

    if (!results.length && style) {
      const styleImage = normalizeInksoftUrl(asString(
        style.imageUrl ||
        style.ImageUrl ||
        style.thumbnailUrl ||
        style.ThumbnailUrl
      ));

      if (styleImage) {
        results.push({
          label: getStyleName(style),
          imageUrl: styleImage,
          thumbnailUrl: styleImage,
          originalUrl: buildOriginalProductImageUrl(styleImage),
          zoomUrl: buildOriginalProductImageUrl(styleImage)
        });
      }
    }

    if (!results.length && product) {
      const fallback = normalizeInksoftUrl(asString(
        product.imageUrl ||
        product.ImageUrl ||
        product.thumbnailUrl ||
        product.ThumbnailUrl
      ));

      if (fallback) {
        results.push({
          label: 'View',
          imageUrl: fallback,
          thumbnailUrl: fallback,
          originalUrl: buildOriginalProductImageUrl(fallback),
          zoomUrl: buildOriginalProductImageUrl(fallback)
        });
      }
    }

    return results;
  }

  function getSizesForStyle(style, product) {
    if (style && asArray(style.sizes).length) return style.sizes;
    if (style && asArray(style.Sizes).length) return style.Sizes;
    if (asArray(product && product.sizes).length) return product.sizes;
    if (asArray(product && product.Sizes).length) return product.Sizes;
    return [];
  }

  function getSizeChartUrl(product) {
    const candidates = [
      product && product.sizeChart && product.sizeChart.url,
      product && product.sizeChartUrl,
      product && product.SizeChartUrl,
      product && product.manufacturer && product.manufacturer.sizeChartUrl,
      product && product.manufacturer && product.manufacturer.SizeChartUrl
    ];

    for (let i = 0; i < candidates.length; i += 1) {
      const url = normalizeInksoftUrl(asString(candidates[i]));
      if (url) return url;
    }

    return '';
  }

  function hasSizeChart(product) {
    if (!product) return false;

    if (product.sizeChart && typeof product.sizeChart.hasSizeChart === 'boolean') {
      return product.sizeChart.hasSizeChart;
    }

    if (product.manufacturer && typeof product.manufacturer.hasSizeChart === 'boolean') {
      return product.manufacturer.hasSizeChart;
    }

    return !!getSizeChartUrl(product);
  }

  function rewriteJitBackgroundHex(url, hex) {
    const normalizedUrl = normalizeInksoftUrl(url);
    const normalizedHex = sanitizeHex(hex);

    if (!normalizedUrl) return '';
    if (!normalizedHex) return normalizedUrl;
    if (!isJitImageUrl(normalizedUrl)) return normalizedUrl;

    return normalizedUrl.replace(
      /(\/JITImage\/[^/]+\/[^/]+\/)([A-Fa-f0-9]{6})(\/\d+\.(?:png|gif)(?:\?|#|$))/i,
      function (_match, prefix, _oldHex, suffix) {
        return prefix + normalizedHex + suffix;
      }
    );
  }

  function getProductId() {
    return firstNonEmpty(
      state.product && state.product.id,
      state.product && state.product.ID,
      state.product && state.product.Id,
      state.product && state.product.productId,
      state.product && state.product.ProductId,
      state.product && state.product.productID,
      state.product && state.product.ProductID
    );
  }

  function getSelectedDesignObject() {
    return state.selectedDesign || null;
  }

  function hasLaunchableSelectedDesign() {
    /*
      A design should only be sent into InkSoft Designer when the user
      explicitly clicked "Use This Design", or when it was restored from
      a shared product URL. Browsing/rendering the Design Ideas carousel
      must not affect the blank Design Now launch.
    */
    return Boolean(
      state.selectedDesign &&
      (
        state.selectedDesignConfirmedByUser === true ||
        state.selectedDesignRestoredFromUrl === true
      )
    );
  }

  function getCurrentLaunchStyleId() {
    const currentStyle = getCurrentStyle();
    if (currentStyle) {
      const styleId = getStyleId(currentStyle, 0);
      if (styleId) return styleId;
    }

    if (asString(state.currentStyleId)) {
      return asString(state.currentStyleId);
    }

    return '';
  }

  function getSelectedDesignId() {
    const design = getSelectedDesignObject();
    if (!design) return '';

    const candidates = [
      design.designId,
      design.DesignId,
      design.id,
      design.ID,
      design.Id,
      design.artworkId,
      design.ArtworkId
    ];

    for (let i = 0; i < candidates.length; i += 1) {
      const value = asString(candidates[i]);
      if (value) return value;
    }

    return '';
  }

  function getSelectedDesignShareUrl() {
    const design = getSelectedDesignObject();
    if (!design) return '';

    const rawDesign = (
      design.rawDesign ||
      design.RawDesign ||
      design.debugSelectedDesign ||
      design.DebugSelectedDesign ||
      null
    );

    const candidates = [
      design.launchUrl,
      design.LaunchUrl,
      design.selectedShareUrl,
      design.SelectedShareUrl,
      design.shareUrl,
      design.ShareUrl,
      design.shareLink,
      design.ShareLink,
      design.href,
      design.Href,
      design.url,
      design.Url,

      rawDesign && rawDesign.launchUrl,
      rawDesign && rawDesign.LaunchUrl,
      rawDesign && rawDesign.selectedShareUrl,
      rawDesign && rawDesign.SelectedShareUrl,
      rawDesign && rawDesign.shareUrl,
      rawDesign && rawDesign.ShareUrl,
      rawDesign && rawDesign.shareLink,
      rawDesign && rawDesign.ShareLink,
      rawDesign && rawDesign.href,
      rawDesign && rawDesign.Href,
      rawDesign && rawDesign.url,
      rawDesign && rawDesign.Url
    ];

    for (let i = 0; i < candidates.length; i += 1) {
      const value = normalizeInksoftUrl(candidates[i]);

      /*
        Product-page selected artwork must use the InkSoft share route.
        The query-style /design-studio/design route can drop users into
        Select Product instead of loading the selected artwork.
      */
      if (value && value.indexOf('/design-studio/share/') !== -1) {
        return value;
      }
    }

    return '';
  }

  function getUrlParamValue(names) {
    const params = new URLSearchParams(window.location.search || '');

    for (let i = 0; i < names.length; i += 1) {
      const value = asString(params.get(names[i]));
      if (value) return value;
    }

    return '';
  }

  function getFallbackDesignPreviewUrl(designId) {
    const safeDesignId = asString(designId).replace(/[^0-9]/g, '');

    if (!safeDesignId) return '';

    return (
      'https://cdn.inksoft.com/images/publishers/2959/designs/' +
      encodeURIComponent(safeDesignId) +
      '.front.480.png'
    );
  }

  function getSelectedColorName() {
    const currentStyle = getCurrentStyle();
    return currentStyle ? getStyleName(currentStyle) : '';
  }

  function buildSmartShareUrl() {
    const productId = getProductId();
    const styleId = getCurrentLaunchStyleId();
    const designId = hasLaunchableSelectedDesign() ? getSelectedDesignId() : '';
    const selectedDesign = getSelectedDesignObject();
    const designImageUrl = state.selectedDesign ? getRenderableDesignUrl() : '';
    const selectedColor = getSelectedColorName();

    const url = new URL(window.location.pathname, window.location.origin);

    if (productId) url.searchParams.set('id', productId);
    if (styleId) url.searchParams.set('styleId', styleId);
    if (selectedColor) url.searchParams.set('selectedColor', selectedColor);

    if (designId) {
      url.searchParams.set('designId', designId);
    }

    if (selectedDesign && selectedDesign.name) {
      url.searchParams.set('designName', selectedDesign.name);
    }

    /*
      Include the exact preview artwork URL when available.
      This allows the shared product page to recreate the preview without
      needing to wait for the design ideas section to reload.
    */
    if (designImageUrl) {
      url.searchParams.set('designImageUrl', designImageUrl);
    }

    return url.toString();
  }

  function getShareData() {
    const productName = getProductName();
    const designId = getSelectedDesignId();
    const selectedColor = getSelectedColorName();
    const url = buildSmartShareUrl();

    let title = productName;

    if (designId) {
      title = productName + ' with selected design';
    }

    if (selectedColor) {
      title += ' - ' + selectedColor;
    }

    return {
      title: title,
      url: url,
      hasArtwork: Boolean(designId || state.selectedDesign),
      productId: getProductId(),
      styleId: getCurrentLaunchStyleId(),
      designId: designId,
      selectedColor: selectedColor,
      designImageUrl: state.selectedDesign ? getRenderableDesignUrl() : ''
    };
  }

  function buildDesignObjectFromShareParams() {
    const designId = getUrlParamValue([
      'designId',
      'designID',
      'artworkId',
      'artworkID',
      'templateDesignId'
    ]);
    const designImageUrl = normalizeInksoftUrl(getUrlParamValue([
      'designImageUrl',
      'artworkImageUrl',
      'previewImageUrl'
    ]));
    const designName = getUrlParamValue(['designName', 'artworkName']);

    if (!designId && !designImageUrl) return null;

    const fallbackImage = designImageUrl || getFallbackDesignPreviewUrl(designId);

    return {
      id: designId,
      ID: designId,
      designId: designId,
      DesignId: designId,
      artworkId: designId,
      ArtworkId: designId,
      name: designName || 'Shared Design',
      previewImageUrl: fallbackImage,
      PreviewImageUrl: fallbackImage,
      imageUrl: fallbackImage,
      ImageUrl: fallbackImage,
      rawDesign: {
        id: designId,
        designId: designId,
        thumbnailUrl: fallbackImage,
        imageUrl: fallbackImage
      },
      launchUrl: buildShareStudioUrl(getProductId(), getCurrentLaunchStyleId(), designId),
      shareUrl: buildShareStudioUrl(getProductId(), getCurrentLaunchStyleId(), designId)
    };
  }

  function applySharedStateFromUrl() {
    const requestedStyleId = getUrlParamValue([
      'styleId',
      'selectedStyleId',
      'productStyleId'
    ]);

    if (requestedStyleId && requestedStyleId !== state.currentStyleId) {
      setCurrentStyle(requestedStyleId);
    }

    const sharedDesign = buildDesignObjectFromShareParams();

    if (sharedDesign) {
      state.selectedDesign = sharedDesign;
      state.selectedDesignConfirmedByUser = false;
      state.selectedDesignRestoredFromUrl = true;
      state.designImageFailed = false;
      state.zoomLocked = false;
      renderMainImage();
      clearPreparedDesignLaunch();
      prewarmSelectedDesignLaunch();
    scheduleBlankStylePrewarm('style-change');

      setStatus('Shared product preview loaded with selected artwork.', 'success');
    }
  }


  function ensureInksoftDesignerResourceHints() {
    if (document.getElementById('inksoft-designer-resource-hints')) return;

    const fragment = document.createDocumentFragment();

    [
      ['preconnect', 'https://shop.unisourceapparel.com'],
      ['dns-prefetch', 'https://shop.unisourceapparel.com'],
      ['preconnect', 'https://cdn.inksoft.com'],
      ['dns-prefetch', 'https://cdn.inksoft.com']
    ].forEach(function (item) {
      const link = document.createElement('link');
      link.rel = item[0];
      link.href = item[1];

      if (item[0] === 'preconnect') {
        link.crossOrigin = 'anonymous';
      }

      fragment.appendChild(link);
    });

    const markerEl = document.createElement('meta');
    markerEl.id = 'inksoft-designer-resource-hints';
    markerEl.name = 'inksoft-designer-resource-hints';
    markerEl.content = 'true';

    fragment.appendChild(markerEl);
    document.head.appendChild(fragment);
  }

  function getInksoftStoreBase() {
    return 'https://shop.unisourceapparel.com/Unisource_Apparel';
  }

  function buildShareStudioUrl(productId, styleId, designId) {
    const safeProductId = asString(productId);
    const safeStyleId = asString(styleId);
    const safeDesignId = asString(designId);

    if (!safeProductId || !safeStyleId) return '';

    let url = (
      getInksoftStoreBase() +
      '/shop/design-studio/share/' +
      encodeURIComponent(safeProductId) +
      '/' +
      encodeURIComponent(safeStyleId)
    );

    if (safeDesignId) {
      url += '/' + encodeURIComponent(safeDesignId);
    }

    return url;
  }

  function getBlankStylePrewarmKey(productId, styleId) {
    return [asString(productId), asString(styleId)].join('|');
  }

  function destroyBlankStylePrewarm(reason) {
    if (state.blankStylePrewarmTimer) {
      window.clearTimeout(state.blankStylePrewarmTimer);
      state.blankStylePrewarmTimer = null;
    }

    if (state.blankStylePrewarmIframe && state.blankStylePrewarmIframe.parentNode) {
      try {
        state.blankStylePrewarmIframe.onload = null;
        state.blankStylePrewarmIframe.src = 'about:blank';
        state.blankStylePrewarmIframe.removeAttribute('src');
        state.blankStylePrewarmIframe.parentNode.removeChild(state.blankStylePrewarmIframe);
      } catch (error) {
        console.warn('[Inksoft Product Page] Blank style prewarm iframe cleanup skipped.', error);
      }
    }

    state.blankStylePrewarmIframe = null;
    state.blankStylePrewarmKey = '';
    state.blankStylePrewarmUrl = '';
    state.blankStylePrewarmStartedAt = 0;
    state.blankStylePrewarmLoadedAt = 0;

    console.log('[Inksoft Product Page] Blank style prewarm cleared', {
      reason: reason || 'clear'
    });
  }

  function scheduleBlankStylePrewarm(reason) {
    /*
      Controlled blank-apparel prewarm:
      - Only prewarm the currently selected product/color.
      - Continue warming the selected product/color even if artwork is chosen.
      - Use one hidden iframe only.
      - Debounce style changes so fast swatch clicking does not launch many InkSoft sessions.
    */
    if (state.blankStylePrewarmTimer) {
      window.clearTimeout(state.blankStylePrewarmTimer);
      state.blankStylePrewarmTimer = null;
    }

    if (!state.product) return;

    const productId = getProductId();
    const styleId = getCurrentLaunchStyleId();

    if (!productId || !styleId) return;

    const key = getBlankStylePrewarmKey(productId, styleId);
    const url = buildShareStudioUrl(productId, styleId, '');

    if (!url) return;

    if (
      state.blankStylePrewarmIframe &&
      state.blankStylePrewarmKey === key &&
      state.blankStylePrewarmUrl === url
    ) {
      return;
    }

    state.blankStylePrewarmTimer = window.setTimeout(function () {
      ensureInksoftDesignerResourceHints();

      const latestProductId = getProductId();
      const latestStyleId = getCurrentLaunchStyleId();
      const latestKey = getBlankStylePrewarmKey(latestProductId, latestStyleId);
      const latestUrl = buildShareStudioUrl(latestProductId, latestStyleId, '');

      if (!latestProductId || !latestStyleId || !latestUrl) return;
      if (latestKey !== key || latestUrl !== url) return;

      if (state.blankStylePrewarmIframe && state.blankStylePrewarmIframe.parentNode) {
        try {
          state.blankStylePrewarmIframe.onload = null;
          state.blankStylePrewarmIframe.src = 'about:blank';
          state.blankStylePrewarmIframe.removeAttribute('src');
          state.blankStylePrewarmIframe.parentNode.removeChild(state.blankStylePrewarmIframe);
        } catch (_error) {}
      }

      const iframe = document.createElement('iframe');
      iframe.id = 'inksoft-blank-style-prewarm-frame';
      iframe.title = 'InkSoft Designer prewarm';
      iframe.setAttribute('aria-hidden', 'true');
      iframe.tabIndex = -1;
      iframe.style.position = 'fixed';
      iframe.style.width = '1px';
      iframe.style.height = '1px';
      iframe.style.left = '-9999px';
      iframe.style.top = '-9999px';
      iframe.style.opacity = '0';
      iframe.style.pointerEvents = 'none';
      iframe.style.border = '0';
      iframe.style.visibility = 'hidden';
      iframe.referrerPolicy = 'strict-origin-when-cross-origin';

      iframe.onload = function () {
        if (state.blankStylePrewarmIframe !== iframe) return;
        state.blankStylePrewarmLoadedAt = Date.now();

        console.log('[Inksoft Product Page] Blank style prewarm loaded', {
          reason: reason || 'style-change',
          productId: latestProductId,
          styleId: latestStyleId,
          key: latestKey,
          elapsedMs: state.blankStylePrewarmLoadedAt - state.blankStylePrewarmStartedAt,
          url: latestUrl
        });
      };

      state.blankStylePrewarmIframe = iframe;
      state.blankStylePrewarmKey = latestKey;
      state.blankStylePrewarmUrl = latestUrl;
      state.blankStylePrewarmStartedAt = Date.now();
      state.blankStylePrewarmLoadedAt = 0;

      document.body.appendChild(iframe);

      /*
        Assign src after append to reliably start loading in all browsers.
      */
      window.setTimeout(function () {
        if (state.blankStylePrewarmIframe !== iframe) return;
        iframe.src = latestUrl;
      }, 25);

      console.log('[Inksoft Product Page] Blank style prewarm started', {
        reason: reason || 'style-change',
        productId: latestProductId,
        styleId: latestStyleId,
        key: latestKey,
        url: latestUrl
      });
    }, reason === 'initial-product-render' ? 75 : 150);
  }

  function getBlankStylePrewarmStatus(productId, styleId) {
    const key = getBlankStylePrewarmKey(productId, styleId);

    if (
      state.blankStylePrewarmIframe &&
      state.blankStylePrewarmKey === key
    ) {
      return {
        key: key,
        url: state.blankStylePrewarmUrl,
        startedAt: state.blankStylePrewarmStartedAt,
        loadedAt: state.blankStylePrewarmLoadedAt,
        elapsedMs: state.blankStylePrewarmStartedAt ? Date.now() - state.blankStylePrewarmStartedAt : 0,
        loaded: Boolean(state.blankStylePrewarmLoadedAt)
      };
    }

    return null;
  }

  function buildFastDesignerUrl(productId, styleId, designId) {
    const safeProductId = asString(productId);
    const safeStyleId = asString(styleId);
    const safeDesignId = asString(designId);

    if (!safeProductId || !safeStyleId) return '';

    const params = new URLSearchParams();
    params.set('productId', safeProductId);
    params.set('productStyleId', safeStyleId);

    if (safeDesignId) {
      params.set('designId', safeDesignId);
    }

    return getInksoftStoreBase() + '/shop/design-studio/design?' + params.toString();
  }

  function getDesignOnlineConfig() {
    if (!state.product) return null;

    if (state.product.designOnline && typeof state.product.designOnline === 'object') {
      return state.product.designOnline;
    }

    const directUrlCandidates = [
      state.product.designOnlineUrl,
      state.product.DesignOnlineUrl,
      state.product.inksoftDesignUrl,
      state.product.InksoftDesignUrl,
      state.product.designStudioUrl,
      state.product.DesignStudioUrl
    ];

    for (let i = 0; i < directUrlCandidates.length; i += 1) {
      const value = normalizeInksoftUrl(directUrlCandidates[i]);
      if (value) {
        return {
          mode: 'hosted',
          url: value
        };
      }
    }

    return null;
  }

  function applyLaunchParamsToUrl(baseUrl, paramsToApply) {
    const rawUrl = asString(baseUrl);
    if (!rawUrl) return '';

    try {
      const url = rawUrl.indexOf('http') === 0
        ? new URL(rawUrl)
        : new URL(rawUrl, window.location.origin);

      Object.keys(paramsToApply).forEach(function (key) {
        const value = asString(paramsToApply[key]);
        if (!value) return;
        url.searchParams.set(key, value);
      });

      return url.toString();
    } catch (error) {
      console.warn('[Inksoft Product Page] Failed to parse backend launch URL. Using raw value.', {
        baseUrl: rawUrl,
        error: error
      });
      return rawUrl;
    }
  }

  function replaceLaunchTokens(urlTemplate, tokenValues) {
    let url = asString(urlTemplate);
    if (!url) return '';

    Object.keys(tokenValues).forEach(function (token) {
      const value = encodeURIComponent(asString(tokenValues[token]));
      url = url.replace(new RegExp('\\{' + token + '\\}', 'g'), value);
    });

    return url;
  }

  function buildDesignStudioPageUrl() {
    const productId = getProductId();
    const styleId = getCurrentLaunchStyleId();
    const designId = getSelectedDesignId();

    const tokenValues = {
      productId: productId,
      styleId: styleId,
      productStyleId: styleId,
      designId: designId
    };

    const backendConfig = getDesignOnlineConfig();

    if (backendConfig) {
      const backendUrl = normalizeInksoftUrl(
        backendConfig.url ||
        backendConfig.href ||
        backendConfig.launchUrl ||
        backendConfig.LaunchUrl
      );

      if (backendUrl) {
        const withTokens = replaceLaunchTokens(backendUrl, tokenValues);
        return applyLaunchParamsToUrl(withTokens, {
          productId: productId,
          styleId: styleId,
          productStyleId: styleId,
          designId: designId
        });
      }
    }

    if (!productId) return '';

    const params = new URLSearchParams();
    params.set('productId', productId);

    if (styleId) {
      params.set('styleId', styleId);
    }

    if (designId) {
      params.set('designId', designId);
    }

    return '/pages/design-studio?' + params.toString();
  }

  async function resolveMappedDesignLaunch(productId, styleId, templateDesignId) {
    const safeProductId = asString(productId);
    const safeStyleId = asString(styleId);
    const safeTemplateDesignId = asString(templateDesignId);

    if (!safeProductId || !safeStyleId || !safeTemplateDesignId) {
      return {
        success: false,
        reason: 'Missing productId, styleId, or template designId.',
        shareUrl: '',
        mappedDesignId: '',
        raw: null
      };
    }

    try {
      const payload = await window.InksoftPOC.api.getDesignMap({
        productId: safeProductId,
        styleId: safeStyleId,
        designId: safeTemplateDesignId,
        prepare: false
      });

      const data = payload && payload.data ? payload.data : payload;

      const shareUrl = normalizeInksoftUrl(
        data && (
          data.shareUrl ||
          data.ShareUrl ||
          data.launchUrl ||
          data.LaunchUrl ||
          data.href ||
          data.Href ||
          ''
        )
      );

      const mappedDesignId = asString(
        data && (
          data.mappedDesignId ||
          data.MappedDesignId ||
          data.designId ||
          data.DesignId ||
          data.id ||
          data.ID ||
          ''
        )
      );

      return {
        // Some backend versions return a valid shareUrl without success:true.
        // Treat shareUrl as usable so Design Online does not fall back incorrectly.
        success: Boolean(shareUrl),
        reason: data && data.note ? String(data.note) : '',
        shareUrl: shareUrl,
        mappedDesignId: mappedDesignId,
        raw: data
      };
    } catch (error) {
      return {
        success: false,
        reason: error && error.message ? error.message : 'Design mapping lookup failed.',
        shareUrl: '',
        mappedDesignId: '',
        raw: null
      };
    }
  }

  function getLaunchContext(options) {
    const mode = asString(options && options.mode) || 'design';
    const productId = getProductId();
    const styleId = getCurrentLaunchStyleId();
    const launchableDesign = mode !== 'upload' && hasLaunchableSelectedDesign();
    const designId = launchableDesign ? getSelectedDesignId() : '';
    const selectedShareUrl = launchableDesign ? getSelectedDesignShareUrl() : '';

    return {
      mode: mode,
      productId: productId,
      styleId: styleId,
      designId: designId,
      selectedShareUrl: selectedShareUrl,
      wrapperUrl: buildDesignStudioPageUrl(),
      backendDesignOnline: getDesignOnlineConfig(),
      finalLaunchUrl: '',
      finalLaunchDesignId: '',
      launchStrategy: '',
      mappingRaw: null
    };
  }

  function getPreparedLaunchKey(productId, styleId, designId) {
    return [asString(productId), asString(styleId), asString(designId)].join('|');
  }

  function getPreparedLaunchForContext(context) {
    if (!state.preparedDesignLaunch) return null;

    const key = getPreparedLaunchKey(context.productId, context.styleId, context.designId);

    if (state.preparedDesignLaunch.key !== key) return null;
    if (!state.preparedDesignLaunch.launchUrl) return null;

    return state.preparedDesignLaunch;
  }

  function isMappedPreparedLaunch(preparedLaunch) {
    if (!preparedLaunch || !preparedLaunch.launchUrl) return false;

    const strategy = asString(preparedLaunch.strategy);

    return (
      strategy.indexOf('mapped') !== -1 ||
      Boolean(preparedLaunch.mappingRaw && preparedLaunch.mappingRaw.shareUrl)
    );
  }


  function clearPreparedDesignLaunch() {
    state.preparedDesignLaunch = null;
    state.preparedDesignLaunchPromise = null;
  }

  function prewarmSelectedDesignLaunch() {
    const context = getLaunchContext({ mode: 'design' });

    if (!context.productId || !context.styleId || !context.designId) return;

    const key = getPreparedLaunchKey(context.productId, context.styleId, context.designId);

    if (
      state.preparedDesignLaunch &&
      state.preparedDesignLaunch.key === key &&
      state.preparedDesignLaunch.launchUrl
    ) {
      return;
    }

    if (
      state.preparedDesignLaunchPromise &&
      state.preparedDesignLaunchPromise.key === key
    ) {
      return;
    }

    /*
      Prewarm should only save backend-mapped launch URLs.
      Do not cache raw /share/{product}/{style}/{design} fallbacks here,
      because that route is the one producing inconsistent 1–13 minute loads.
    */
    const promise = resolveMappedDesignLaunch(
      context.productId,
      context.styleId,
      context.designId
    )
      .then(function (mapping) {
        if (!mapping || !mapping.shareUrl) {
          state.preparedDesignLaunch = null;

          console.log('[Inksoft Product Page] Background Designer mapping unavailable. Product page will use launch-safe artwork guidance on click.', {
            productId: context.productId,
            styleId: context.styleId,
            designId: context.designId,
            mapping: mapping
          });

          return null;
        }

        const finalDesignId = mapping.mappedDesignId || context.designId;

        state.preparedDesignLaunch = {
          key: key,
          productId: context.productId,
          styleId: context.styleId,
          designId: finalDesignId,
          templateDesignId: context.designId,
          launchUrl: mapping.shareUrl,
          shareUrl: mapping.shareUrl,
          selectedShareUrl: mapping.shareUrl,
          mappingRaw: mapping.raw || null,
          strategy: 'background-prepared-mapped-share-url'
        };

        console.log('[Inksoft Product Page] Background prepared Designer launch', state.preparedDesignLaunch);

        return state.preparedDesignLaunch;
      })
      .catch(function (error) {
        console.warn('[Inksoft Product Page] Background Designer mapping failed. Product page will use launch-safe artwork guidance on click.', error);

        state.preparedDesignLaunch = null;
        return null;
      })
      .finally(function () {
        if (
          state.preparedDesignLaunchPromise &&
          state.preparedDesignLaunchPromise.key === key
        ) {
          state.preparedDesignLaunchPromise = null;
        }
      });

    promise.key = key;
    state.preparedDesignLaunchPromise = promise;
  }


  function ensureArtworkLaunchModalStyles() {
    if (document.getElementById('inksoft-artwork-launch-modal-styles')) return;

    const style = document.createElement('style');
    style.id = 'inksoft-artwork-launch-modal-styles';
    style.textContent = `
      .inksoft-artwork-launch-modal {
        position: fixed;
        inset: 0;
        z-index: 999999;
        display: none;
        align-items: center;
        justify-content: center;
        padding: 24px;
      }

      .inksoft-artwork-launch-modal.is-open {
        display: flex;
      }

      .inksoft-artwork-launch-modal__backdrop {
        position: absolute;
        inset: 0;
        background: rgba(10, 20, 35, 0.58);
        backdrop-filter: blur(2px);
      }

      .inksoft-artwork-launch-modal__dialog {
        position: relative;
        width: min(560px, calc(100vw - 40px));
        border-radius: 22px;
        background: #ffffff;
        box-shadow: 0 28px 80px rgba(9, 30, 66, 0.28);
        padding: 30px;
        color: #172033;
      }

      .inksoft-artwork-launch-modal__close {
        position: absolute;
        top: 16px;
        right: 16px;
        width: 36px;
        height: 36px;
        border: 1px solid #dfe6ef;
        border-radius: 999px;
        background: #ffffff;
        color: #526174;
        font-size: 22px;
        line-height: 1;
        cursor: pointer;
      }

      .inksoft-artwork-launch-modal__eyebrow {
        margin-bottom: 10px;
        color: #f47b20;
        font-size: 12px;
        font-weight: 800;
        letter-spacing: 0.08em;
        text-transform: uppercase;
      }

      .inksoft-artwork-launch-modal__title {
        margin: 0 34px 14px 0;
        color: #0f3b73;
        font-size: 28px;
        line-height: 1.12;
        font-weight: 900;
      }

      .inksoft-artwork-launch-modal__body {
        margin: 0;
        color: #4d5d73;
        font-size: 15px;
        line-height: 1.6;
      }

      .inksoft-artwork-launch-modal__context {
        margin-top: 18px;
        padding: 14px 16px;
        border: 1px solid #dfe6ef;
        border-radius: 14px;
        background: #f6f9fd;
        color: #34445a;
        font-size: 13px;
        line-height: 1.55;
      }

      .inksoft-artwork-launch-modal__actions {
        display: grid;
        grid-template-columns: 1fr 1fr;
        gap: 12px;
        margin-top: 22px;
        align-items: center;
      }

      .inksoft-artwork-launch-modal__primary,
      .inksoft-artwork-launch-modal__secondary {
        min-height: 48px;
        display: inline-flex;
        align-items: center;
        justify-content: center;
        text-align: center;
        text-decoration: none;
      }

      .inksoft-artwork-launch-modal__text-button {
        grid-column: 1 / -1;
        border: 0;
        background: transparent;
        color: #6a778b;
        font-size: 13px;
        font-weight: 700;
        text-decoration: underline;
        cursor: pointer;
        padding: 8px;
      }

      .inksoft-artwork-launch-modal__secondary {
        background: #f8fbff !important;
        color: #0f3b73 !important;
        border: 1px solid #dfe6ef !important;
        box-shadow: none !important;
      }

      @media (max-width: 640px) {
        .inksoft-artwork-launch-modal__dialog {
          padding: 24px;
        }

        .inksoft-artwork-launch-modal__title {
          font-size: 23px;
        }

        .inksoft-artwork-launch-modal__actions {
          grid-template-columns: 1fr;
        }

        .inksoft-artwork-launch-modal__text-button {
          grid-column: auto;
        }
      }
    `;

    document.head.appendChild(style);
  }

  function closeArtworkLaunchModal() {
    const modal = document.getElementById('inksoft-artwork-launch-modal');
    if (!modal) return;

    modal.classList.remove('is-open');
    modal.setAttribute('aria-hidden', 'true');
    document.body.style.overflow = '';
  }

  function openArtworkLaunchModal(context, finalLaunchUrl, finalLaunchDesignId, onContinue) {
    if (typeof onContinue === 'function') {
      onContinue();
    }

    return false;
  }

  function shouldGateSlowArtworkLaunch(context, launchStrategy) {
    /*
      Warning flow disabled:
      Do not show the "This design may take longer to open" block/modal.
      Product-page selected artwork will launch directly using the existing
      product/style/artwork share route.
    */
    return false;
  }


  function buildDesignerResetReloadUrl() {
    const productId = getProductId();
    const styleId = getCurrentLaunchStyleId();
    const selectedColor = getSelectedColorName();

    try {
      const url = new URL(window.location.pathname, window.location.origin);

      if (productId) url.searchParams.set('id', productId);
      if (styleId) url.searchParams.set('styleId', styleId);
      if (selectedColor) url.searchParams.set('selectedColor', selectedColor);

      /*
        Cache-buster intentionally added so the browser fully reloads the page
        and does not reuse the previous Shopify/Designer embed state.
      */
      url.searchParams.set('_designerReset', String(Date.now()));

      return url.toString();
    } catch (_error) {
      return window.location.href;
    }
  }

  function enableDesignerReloadOnClose() {
    if (
      window.InksoftPOC &&
      window.InksoftPOC.designerEmbed &&
      typeof window.InksoftPOC.designerEmbed.setReloadOnClose === 'function'
    ) {
      const reloadUrl = buildDesignerResetReloadUrl();

      window.__unisourceDesignerReloadUrl = reloadUrl;

      window.InksoftPOC.designerEmbed.setReloadOnClose({
        enabled: true,
        url: reloadUrl
      });
    }
  }

  function resetDesignerEmbedBeforeLaunch() {
    if (
      window.InksoftPOC &&
      window.InksoftPOC.designerEmbed &&
      typeof window.InksoftPOC.designerEmbed.reset === 'function'
    ) {
      window.InksoftPOC.designerEmbed.reset('before-design-studio-launch');
    }
  }

  async function launchDesignStudio(options) {
    resetDesignerEmbedBeforeLaunch();
    ensureInksoftDesignerResourceHints();

    const context = getLaunchContext(options);
    const mode = context.mode;

    if (!context.productId || !context.styleId) {
      setStatus('Unable to launch Design Studio because product or style information is incomplete.', 'error');
      return;
    }

    /*
      Correct launch split:
      - No selected artwork: use the InkSoft share product/style URL.
        This opens the selected blank product/color. The embed layer must preserve
        this as product/style only and must not recover artwork from DOM/storage.
      - Explicit selected artwork: use the InkSoft /share/{product}/{style}/{design}
        route, because that is the route that reliably preserves artwork.
    */

    const selectedTemplateDesignId = context.designId || '';

    let finalLaunchUrl = '';
    let finalLaunchDesignId = selectedTemplateDesignId || '';
    let launchStrategy = '';

    const preparedLaunch = mode === 'upload'
      ? null
      : getPreparedLaunchForContext(context);

    if (mode === 'upload') {
      finalLaunchUrl = buildShareStudioUrl(context.productId, context.styleId, '');
      finalLaunchDesignId = '';
      launchStrategy = 'blank-product-style-share-url';
    } else if (!selectedTemplateDesignId) {
      finalLaunchUrl = buildShareStudioUrl(context.productId, context.styleId, '');
      finalLaunchDesignId = '';
      launchStrategy = 'blank-product-style-share-url';
    } else if (isMappedPreparedLaunch(preparedLaunch)) {
      finalLaunchUrl = preparedLaunch.launchUrl;
      finalLaunchDesignId = preparedLaunch.designId || selectedTemplateDesignId || '';
      launchStrategy = preparedLaunch.strategy || 'background-prepared-mapped-share-url';
      context.mappingRaw = preparedLaunch.mappingRaw || null;
    } else if (context.selectedShareUrl) {
      finalLaunchUrl = context.selectedShareUrl;
      finalLaunchDesignId = selectedTemplateDesignId || '';
      launchStrategy = 'guarded-selected-artwork-share-url';
    } else {
      finalLaunchUrl = buildShareStudioUrl(
        context.productId,
        context.styleId,
        selectedTemplateDesignId
      );
      finalLaunchDesignId = selectedTemplateDesignId;
      launchStrategy = 'guarded-product-style-artwork-share-url';
    }

    if (!finalLaunchUrl) {
      if (context.wrapperUrl) {
        finalLaunchUrl = context.wrapperUrl;
        launchStrategy = launchStrategy
          ? (launchStrategy + '-wrapper-url-fallback')
          : 'wrapper-url-fallback';
      } else {
        setStatus('Unable to build InkSoft Designer URL.', 'error');
        return;
      }
    }

    context.finalLaunchUrl = finalLaunchUrl;
    context.finalLaunchDesignId = finalLaunchDesignId || context.designId || '';
    context.launchStrategy = launchStrategy;
    context.mappingRaw = context.mappingRaw || null;
    state.lastLaunchContext = context;

    const continueLaunch = function () {
      setStatus(
        finalLaunchDesignId
          ? 'Launching Designer with selected artwork. This may take a little longer for custom product/color combinations.'
          : 'Launching Designer with current product and color only.',
        finalLaunchDesignId ? 'success' : 'info'
      );

      const blankPrewarmStatus = getBlankStylePrewarmStatus(
        context.productId,
        context.styleId
      );

      if (blankPrewarmStatus) {
        console.log('[Inksoft Product Page] Launching Designer with prewarm status', blankPrewarmStatus);
      }

      console.log('[Inksoft Product Page] Launching Design Studio', context);

      /*
        Keep the hidden prewarm iframe alive until the visible Designer launch begins,
        then remove it so the customer does not run two InkSoft Designer instances.
      */
      if (blankPrewarmStatus) {
        window.setTimeout(function () {
          destroyBlankStylePrewarm('visible-designer-launch-started');
        }, 700);
      }

      /*
        Open InkSoft as a standalone top-level page instead of inside the
        Shopify iframe. This avoids the ghost modal issue during quantity,
        cart, and checkout while preserving the exact prepared launch URL.
      */
      const designStudioWindow = window.open(
        finalLaunchUrl,
        '_blank'
      );

      /*
        Use the current tab only when the browser blocks the new tab.
      */
      if (!designStudioWindow) {
        window.location.assign(finalLaunchUrl);
        return;
      }

      /*
        Disconnect the InkSoft tab from the Shopify opener where supported.
      */
      try {
        designStudioWindow.opener = null;
      } catch (error) {
        console.warn(
          '[Inksoft Product Page] Unable to clear Design Studio opener.',
          error
        );
      }

      return;
    };

    if (shouldGateSlowArtworkLaunch(context, launchStrategy)) {
      setStatus('This design needs preparation for the selected product/color before opening reliably in Designer.', 'info');

      openArtworkLaunchModal(
        context,
        finalLaunchUrl,
        finalLaunchDesignId,
        continueLaunch
      );
      return;
    }

    continueLaunch();
  }

  function getProductName() {
    return firstNonEmpty(
      state.product && state.product.name,
      state.product && state.product.Name,
      'Unnamed Product'
    );
  }

  function getManufacturerSku() {
    return firstNonEmpty(
      state.product && state.product.manufacturerSku,
      state.product && state.product.manufacturerSKU,
      state.product && state.product.ManufacturerSku,
      state.product && state.product.ManufacturerSKU,
      state.product && state.product.manufacturerStyleCode,
      state.product && state.product.ManufacturerStyleCode,
      state.product && state.product.sku,
      state.product && state.product.Sku
    );
  }

  function getCurrentProductImageUrl() {
    const currentImage = state.currentImages[state.currentImageIndex];

    return normalizeInksoftUrl(firstNonEmpty(
      currentImage && currentImage.imageUrl,
      currentImage && currentImage.thumbnailUrl,
      state.product && state.product.imageUrl,
      state.product && state.product.ImageUrl,
      state.product && state.product.thumbnailUrl,
      state.product && state.product.ThumbnailUrl
    ));
  }

  function getRequestedQuantity() {
    const input = document.getElementById('inksoft-quote-qty');
    const value = input ? Number(input.value || 1) : 1;

    if (!Number.isFinite(value) || value < 1) return 1;
    return Math.floor(value);
  }

  function buildRequestQuoteUrl() {
    const params = new URLSearchParams();
    const currentStyle = getCurrentStyle();
    const productId = getProductId();
    const productName = getProductName();
    const manufacturerSku = getManufacturerSku();
    const selectedStyleId = getCurrentLaunchStyleId();
    const selectedColor = currentStyle ? getStyleName(currentStyle) : '';
    const productImageUrl = getCurrentProductImageUrl();
    const quantity = getRequestedQuantity();

    if (productId) params.set('productId', productId);
    if (productName) params.set('productName', productName);
    if (manufacturerSku) params.set('manufacturerSku', manufacturerSku);
    if (selectedStyleId) params.set('selectedStyleId', selectedStyleId);
    if (selectedColor) params.set('selectedColor', selectedColor);
    if (productImageUrl) params.set('productImageUrl', productImageUrl);
    if (quantity > 0) params.set('quantity', String(quantity));

    params.set('sourcePageUrl', window.location.href);

    return '/pages/request-a-quote?' + params.toString();
  }

  function openRequestQuoteForm() {
    window.location.href = buildRequestQuoteUrl();
  }

  function renderShell() {
    const root = getRoot();
    if (!root) return;

    root.innerHTML = `
      <div class="inksoft-product-layout">
        <section class="inksoft-product-gallery">
          <div id="inksoft-product-main-image-wrap" class="inksoft-product-main-image-wrap">
            <div id="inksoft-product-main-stage" class="inksoft-product-main-stage"></div>
            <div class="inksoft-product-zoom-hint">Hover to zoom • Click to lock</div>
          </div>

          <div id="inksoft-product-thumbs" class="inksoft-product-thumbs"></div>
        </section>

        <section class="inksoft-product-detail">
          <h1 id="inksoft-product-title" class="inksoft-product-title"></h1>

          <div id="inksoft-product-meta" class="inksoft-product-meta"></div>

          <div class="inksoft-product-panel">
            <div class="inksoft-product-panel__title">Color Options</div>
            <div id="inksoft-product-swatches" class="inksoft-product-swatches"></div>
          </div>

          <div class="inksoft-product-panel">
            <div class="inksoft-product-panel__title">Available Sizes</div>
            <div id="inksoft-product-sizes" class="inksoft-product-sizes"></div>
          </div>

          <div class="inksoft-product-cta-row">
            <button type="button" class="inksoft-btn" id="inksoft-btn-design-online">DESIGN, PRICE &amp; ORDER</button>
            <button type="button" class="inksoft-btn inksoft-btn--secondary" id="inksoft-btn-request-quote">ASK FOR HELP</button>
          </div>

          <div class="inksoft-product-tabs-wrap">
            <div class="inksoft-product-tabs" id="inksoft-product-tabs">
              <button type="button" class="inksoft-product-tab is-active" data-tab="description">Description</button>
              <button type="button" class="inksoft-product-tab" data-tab="size-chart">Size Chart</button>
            </div>

            <div class="inksoft-product-tab-panels">
              <div id="inksoft-product-panel-description" class="inksoft-product-tab-panel is-active"></div>
              <div id="inksoft-product-panel-size-chart" class="inksoft-product-tab-panel"></div>
            </div>
          </div>
        </section>
      </div>

      <section id="inksoft-design-ideas-host" class="inksoft-product-next-sections"></section>
      <section id="inksoft-product-next-sections" class="inksoft-product-next-sections"></section>

      <div id="inksoft-artwork-launch-modal" class="inksoft-artwork-launch-modal" aria-hidden="true" hidden style="display:none !important;">
        <div class="inksoft-artwork-launch-modal__backdrop" data-inksoft-artwork-modal-close="true"></div>
        <div class="inksoft-artwork-launch-modal__dialog" role="dialog" aria-modal="true" aria-labelledby="inksoft-artwork-launch-modal-title">
          <button
            type="button"
            class="inksoft-artwork-launch-modal__close"
            data-inksoft-artwork-modal-close="true"
            aria-label="Close"
          >×</button>

          <div class="inksoft-artwork-launch-modal__eyebrow">Artwork preparation required</div>
          <h2 id="inksoft-artwork-launch-modal-title" class="inksoft-artwork-launch-modal__title">
            This design may take longer to open
          </h2>

          <p class="inksoft-artwork-launch-modal__body">
            This selected design may take longer to open in InkSoft Designer for the current product/color.
            You may continue to Designer, or ask our team for help preparing this design.
          </p>

          <div id="inksoft-artwork-launch-modal-context" class="inksoft-artwork-launch-modal__context"></div>

          <div class="inksoft-artwork-launch-modal__actions">
            <button type="button" class="inksoft-btn inksoft-artwork-launch-modal__primary" id="inksoft-artwork-modal-continue">
              Continue to Designer
            </button>
            <button type="button" class="inksoft-btn inksoft-btn--secondary inksoft-artwork-launch-modal__secondary" id="inksoft-artwork-modal-help">
              Ask for Help
            </button>
            <button type="button" class="inksoft-artwork-launch-modal__text-button" data-inksoft-artwork-modal-close="true">
              Cancel
            </button>
          </div>
        </div>
      </div>

    `;
  }

  function renderMeta(product) {
    const el = document.getElementById('inksoft-product-meta');
    if (!el) return;

    const sku = firstNonEmpty(
      product && product.sku,
      product && product.Sku,
      product && product.SKU,
      product && product.productSku,
      product && product.ProductSKU
    );

    const brand = firstNonEmpty(
      product && product.brand,
      product && product.Brand,
      product && product.manufacturerName,
      product && product.ManufacturerName,
      product && product.manufacturer && product.manufacturer.name,
      product && product.manufacturer && product.manufacturer.Name
    );

    let html = '';

    if (sku) {
      html +=
        '<div class="inksoft-product-meta__line ua-product-detail-sku">' +
          'SKU: <strong>' + core.escapeHtml(sku) + '</strong>' +
        '</div>';
    }

    if (brand) {
      html +=
        '<div class="inksoft-product-meta__line ua-product-detail-brand">' +
          'Brand: <strong>' + core.escapeHtml(brand) + '</strong>' +
        '</div>';
    }

    el.innerHTML = html;
  }

  function renderTabPanels(product) {
    const descEl = document.getElementById('inksoft-product-panel-description');
    const chartEl = document.getElementById('inksoft-product-panel-size-chart');

    if (descEl) {
      const descriptionHtml = product.description || product.Description || '';
      descEl.innerHTML = descriptionHtml || '<div class="inksoft-product-empty">No description available.</div>';
    }

    if (chartEl) {
      const chartUrl = getSizeChartUrl(product);
      const chartExists = hasSizeChart(product) && !!chartUrl;

      if (!chartExists) {
        chartEl.innerHTML = '<div class="inksoft-product-empty">No size chart available.</div>';
        return;
      }

      if (isPdfUrl(chartUrl)) {
        chartEl.innerHTML = `
          <div class="inksoft-size-chart-wrap">
            <div class="inksoft-size-chart-actions">
              <a
                href="${core.escapeHtml(chartUrl)}"
                target="_blank"
                rel="noopener noreferrer"
                class="inksoft-btn inksoft-size-chart-link"
              >
                Open Size Chart PDF
              </a>
            </div>

            <div class="inksoft-size-chart-pdf-wrap">
              <iframe
                src="${core.escapeHtml(chartUrl)}"
                class="inksoft-size-chart-pdf"
                title="Size Chart PDF"
                loading="lazy"
              ></iframe>
            </div>
          </div>
        `;
        return;
      }

      if (isImageUrl(chartUrl)) {
        chartEl.innerHTML = `
          <div class="inksoft-size-chart-wrap">
            <div class="inksoft-size-chart-actions">
              <a
                href="${core.escapeHtml(chartUrl)}"
                target="_blank"
                rel="noopener noreferrer"
                class="inksoft-btn inksoft-size-chart-link"
              >
                Open Size Chart
              </a>
            </div>

            <div class="inksoft-size-chart-image-wrap">
              <img
                src="${core.escapeHtml(chartUrl)}"
                alt="Size Chart"
                class="inksoft-size-chart-image"
                loading="lazy"
              >
            </div>
          </div>
        `;
        return;
      }

      chartEl.innerHTML = `
        <div class="inksoft-size-chart-wrap">
          <div class="inksoft-product-empty">Size chart is available, but format could not be previewed inline.</div>
          <div class="inksoft-size-chart-actions" style="margin-top:12px;">
            <a
              href="${core.escapeHtml(chartUrl)}"
              target="_blank"
              rel="noopener noreferrer"
              class="inksoft-btn inksoft-size-chart-link"
            >
              Open Size Chart
            </a>
          </div>
        </div>
      `;
    }
  }

  function bindTabs() {
    const tabsWrap = document.getElementById('inksoft-product-tabs');
    if (!tabsWrap) return;

    Array.prototype.forEach.call(tabsWrap.querySelectorAll('.inksoft-product-tab'), function (button) {
      button.addEventListener('click', function () {
        const tabName = button.getAttribute('data-tab') || 'description';
        state.activeTab = tabName;
        renderActiveTabState();
      });
    });
  }

  function renderActiveTabState() {
    const tabs = document.querySelectorAll('.inksoft-product-tab');
    const panels = document.querySelectorAll('.inksoft-product-tab-panel');

    Array.prototype.forEach.call(tabs, function (tab) {
      const isActive = tab.getAttribute('data-tab') === state.activeTab;
      tab.classList.toggle('is-active', isActive);
    });

    Array.prototype.forEach.call(panels, function (panel) {
      const id = panel.id || '';
      const isDescription = state.activeTab === 'description' && id === 'inksoft-product-panel-description';
      const isChart = state.activeTab === 'size-chart' && id === 'inksoft-product-panel-size-chart';
      panel.classList.toggle('is-active', isDescription || isChart);
    });
  }

  function resetZoomState() {
    state.zoomLocked = false;

    const stage = document.getElementById('inksoft-product-main-stage');
    const wrap = document.getElementById('inksoft-product-main-image-wrap');
    const hint = wrap ? wrap.querySelector('.inksoft-product-zoom-hint') : null;

    if (stage) {
      stage.style.transform = 'scale(1)';
      stage.style.transformOrigin = 'center center';
      stage.classList.remove('is-zoomed');
      stage.style.cursor = isTouchDevice() ? 'default' : 'zoom-in';
    }

    if (hint) {
      hint.textContent = isTouchDevice() ? 'Pinch/zoom disabled on touch devices' : 'Hover to zoom • Click to lock';
    }
  }

  function updateZoomFromPointer(event) {
    const wrap = document.getElementById('inksoft-product-main-image-wrap');
    const stage = document.getElementById('inksoft-product-main-stage');
    if (!wrap || !stage) return;
    if (isTouchDevice()) return;

    const rect = wrap.getBoundingClientRect();
    if (!rect.width || !rect.height) return;

    const x = Math.min(Math.max(event.clientX - rect.left, 0), rect.width);
    const y = Math.min(Math.max(event.clientY - rect.top, 0), rect.height);

    const xPercent = (x / rect.width) * 100;
    const yPercent = (y / rect.height) * 100;

    stage.style.transformOrigin = `${xPercent}% ${yPercent}%`;
    stage.style.transform = 'scale(2.1)';
    stage.classList.add('is-zoomed');
    stage.style.cursor = state.zoomLocked ? 'zoom-out' : 'zoom-in';
  }

  function bindMainImageZoom() {
    const wrap = document.getElementById('inksoft-product-main-image-wrap');
    const stage = document.getElementById('inksoft-product-main-stage');
    const hint = wrap ? wrap.querySelector('.inksoft-product-zoom-hint') : null;

    if (!wrap || !stage) return;

    resetZoomState();

    if (isTouchDevice()) {
      if (hint) hint.textContent = 'Pinch/zoom disabled on touch devices';
      return;
    }

    wrap.addEventListener('mouseenter', function (event) {
      if (state.zoomLocked) return;
      updateZoomFromPointer(event);
      if (hint) hint.textContent = 'Click to lock • Move mouse to pan';
    });

    wrap.addEventListener('mousemove', function (event) {
      if (!state.zoomLocked && !stage.classList.contains('is-zoomed')) {
        updateZoomFromPointer(event);
        return;
      }

      if (state.zoomLocked || stage.classList.contains('is-zoomed')) {
        updateZoomFromPointer(event);
      }
    });

    wrap.addEventListener('mouseleave', function () {
      if (state.zoomLocked) {
        if (hint) hint.textContent = 'Zoom locked • Click image to unlock';
        return;
      }

      stage.style.transform = 'scale(1)';
      stage.style.transformOrigin = 'center center';
      stage.classList.remove('is-zoomed');
      stage.style.cursor = 'zoom-in';

      if (hint) hint.textContent = 'Hover to zoom • Click to lock';
    });

    wrap.addEventListener('click', function (event) {
      if (isTouchDevice()) return;

      if (!state.zoomLocked) {
        state.zoomLocked = true;
        updateZoomFromPointer(event);
        stage.style.cursor = 'zoom-out';
        if (hint) hint.textContent = 'Zoom locked • Click image to unlock';
        return;
      }

      state.zoomLocked = false;
      stage.style.transform = 'scale(1)';
      stage.style.transformOrigin = 'center center';
      stage.classList.remove('is-zoomed');
      stage.style.cursor = 'zoom-in';

      if (hint) hint.textContent = 'Hover to zoom • Click to lock';
    });
  }

  function getRawSelectedDesign() {
    const design = state.selectedDesign || null;

    if (!design) return null;

    return (
      design.rawDesign ||
      design.RawDesign ||
      design.debugSelectedDesign ||
      design.DebugSelectedDesign ||
      design
    );
  }

  function getPreferredDesignImageFromRawDesign(rawDesign) {
    if (!rawDesign || typeof rawDesign !== 'object') return '';

    const styleHex = getCurrentStyleHex();

    const canvasGroups = []
      .concat(asArray(rawDesign.canvases))
      .concat(asArray(rawDesign.Canvases));

    for (let i = 0; i < canvasGroups.length; i += 1) {
      const canvas = canvasGroups[i];

      const thumbnailUrl = normalizeInksoftUrl(asString(
        canvas && (
          canvas.thumbnailUrl ||
          canvas.ThumbnailUrl ||
          canvas.thumbnailURL ||
          canvas.ThumbnailURL
        )
      ));

      if (thumbnailUrl) {
        return rewriteJitBackgroundHex(thumbnailUrl, styleHex);
      }
    }

    const rawThumbnail = normalizeInksoftUrl(asString(
      rawDesign.thumbnailUrl ||
      rawDesign.ThumbnailUrl ||
      rawDesign.thumbnailURL ||
      rawDesign.ThumbnailURL
    ));

    if (rawThumbnail) {
      return rewriteJitBackgroundHex(rawThumbnail, styleHex);
    }

    for (let i = 0; i < canvasGroups.length; i += 1) {
      const canvas = canvasGroups[i];

      const imageUrl = normalizeInksoftUrl(asString(
        canvas && (
          canvas.imageUrl ||
          canvas.ImageUrl ||
          canvas.previewUrl ||
          canvas.PreviewUrl
        )
      ));

      if (imageUrl) return imageUrl;
    }

    return normalizeInksoftUrl(asString(
      rawDesign.imageUrl ||
      rawDesign.ImageUrl ||
      rawDesign.previewImageUrl ||
      rawDesign.PreviewImageUrl ||
      rawDesign.previewUrl ||
      rawDesign.PreviewUrl ||
      rawDesign.artworkUrl ||
      rawDesign.ArtworkUrl
    ));
  }

  function getRenderableDesignUrl() {
    if (!state.selectedDesign) return '';

    const design = state.selectedDesign;
    const rawDesign = getRawSelectedDesign();
    const styleHex = getCurrentStyleHex();

    const preferredRawImage = getPreferredDesignImageFromRawDesign(rawDesign);

    if (!state.designImageFailed && preferredRawImage) {
      return preferredRawImage;
    }

    const preview = normalizeInksoftUrl(asString(
      design.previewImageUrl ||
      design.PreviewImageUrl ||
      rawDesign && rawDesign.thumbnailUrl ||
      rawDesign && rawDesign.ThumbnailUrl ||
      rawDesign && rawDesign.thumbnailURL ||
      rawDesign && rawDesign.ThumbnailURL
    ));

    if (preview) {
      return rewriteJitBackgroundHex(preview, styleHex);
    }

    const primary = normalizeInksoftUrl(asString(
      design.imageUrl ||
      design.ImageUrl ||
      rawDesign && rawDesign.imageUrl ||
      rawDesign && rawDesign.ImageUrl
    ));

    return primary;
  }

  function colorDistanceSquared(aR, aG, aB, bR, bG, bB) {
    const dR = aR - bR;
    const dG = aG - bG;
    const dB = aB - bB;

    return (dR * dR) + (dG * dG) + (dB * dB);
  }

  function getEdgeBackgroundColor(imageData, width, height) {
    const data = imageData.data;
    const points = [
      [0, 0],
      [Math.max(0, width - 1), 0],
      [0, Math.max(0, height - 1)],
      [Math.max(0, width - 1), Math.max(0, height - 1)]
    ];

    let r = 0;
    let g = 0;
    let b = 0;
    let count = 0;

    points.forEach(function (point) {
      const x = point[0];
      const y = point[1];
      const idx = ((y * width) + x) * 4;

      if (data[idx + 3] < 10) return;

      r += data[idx];
      g += data[idx + 1];
      b += data[idx + 2];
      count += 1;
    });

    if (!count) {
      return { r: 245, g: 245, b: 245 };
    }

    return {
      r: Math.round(r / count),
      g: Math.round(g / count),
      b: Math.round(b / count)
    };
  }

  function knockOutConnectedBackground(imageData, width, height) {
    const data = imageData.data;
    const bg = getEdgeBackgroundColor(imageData, width, height);
    const tolerance = 46;
    const toleranceSq = tolerance * tolerance;
    const visited = new Uint8Array(width * height);
    const queue = [];

    function shouldRemovePixel(x, y) {
      if (x < 0 || y < 0 || x >= width || y >= height) return false;

      const pos = (y * width) + x;

      if (visited[pos]) return false;

      const idx = pos * 4;
      const alpha = data[idx + 3];

      if (alpha < 10) return true;

      const distanceSq = colorDistanceSquared(data[idx], data[idx + 1], data[idx + 2], bg.r, bg.g, bg.b);

      return distanceSq <= toleranceSq;
    }

    function enqueue(x, y) {
      if (!shouldRemovePixel(x, y)) return;

      const pos = (y * width) + x;

      visited[pos] = 1;
      queue.push(pos);
    }

    for (let x = 0; x < width; x += 1) {
      enqueue(x, 0);
      enqueue(x, height - 1);
    }

    for (let y = 0; y < height; y += 1) {
      enqueue(0, y);
      enqueue(width - 1, y);
    }

    while (queue.length) {
      const pos = queue.shift();
      const x = pos % width;
      const y = Math.floor(pos / width);
      const idx = pos * 4;

      data[idx + 3] = 0;

      enqueue(x + 1, y);
      enqueue(x - 1, y);
      enqueue(x, y + 1);
      enqueue(x, y - 1);
    }

    return imageData;
  }

  function applyPreviewBackgroundKnockout(img) {
    if (!img || img.dataset.backgroundCleaned === 'true') return;
    if (!state.selectedDesign) return;

    img.dataset.backgroundCleaned = 'true';

    try {
      const naturalWidth = img.naturalWidth || 0;
      const naturalHeight = img.naturalHeight || 0;

      if (!naturalWidth || !naturalHeight) return;

      const canvas = document.createElement('canvas');
      const maxDimension = 900;
      const scale = Math.min(1, maxDimension / Math.max(naturalWidth, naturalHeight));
      const width = Math.max(1, Math.round(naturalWidth * scale));
      const height = Math.max(1, Math.round(naturalHeight * scale));
      const ctx = canvas.getContext('2d', { willReadFrequently: true });

      canvas.width = width;
      canvas.height = height;

      ctx.drawImage(img, 0, 0, width, height);

      const imageData = ctx.getImageData(0, 0, width, height);
      const cleaned = knockOutConnectedBackground(imageData, width, height);

      ctx.putImageData(cleaned, 0, 0);

      img.src = canvas.toDataURL('image/png');
    } catch (error) {
      console.warn('[Inksoft Product Page] Preview background cleanup skipped. The image may not allow canvas processing.', {
        error: error,
        source: img.currentSrc || img.src
      });
    }
  }

  function bindOverlayFallback() {
    const overlay = document.getElementById('inksoft-design-overlay');
    if (!overlay) return;

    if (overlay.complete && overlay.naturalWidth) {
      applyPreviewBackgroundKnockout(overlay);
    } else {
      overlay.addEventListener('load', function () {
        applyPreviewBackgroundKnockout(overlay);
      }, { once: true });
    }

    overlay.addEventListener('error', function () {
      if (!state.selectedDesign) return;
      if (state.designImageFailed) return;

      state.designImageFailed = true;

      console.warn('[Inksoft Product Page] Preferred design asset failed to render. Falling back to preview image.', {
        preferredRawImage: getPreferredDesignImageFromRawDesign(getRawSelectedDesign()),
        fallback: rewriteJitBackgroundHex(state.selectedDesign.previewImageUrl, getCurrentStyleHex()),
        rawDesign: getRawSelectedDesign(),
        selectedDesign: state.selectedDesign,
        styleHex: getCurrentStyleHex()
      });

      renderMainImage();
    }, { once: true });
  }

  function renderMainImage() {
    const stage = document.getElementById('inksoft-product-main-stage');
    if (!stage) return;

    const image = state.currentImages[state.currentImageIndex];

    if (!image) {
      stage.innerHTML = '<div class="inksoft-product-empty">No image available.</div>';
      return;
    }

    const overlayUrl = getRenderableDesignUrl();
    const baseImageUrl = getHighResolutionProductImageUrl(image) || image.imageUrl;

    const overlayMarkup = state.selectedDesign && overlayUrl
      ? `
        <img
          id="inksoft-design-overlay"
          class="inksoft-design-overlay"
          crossorigin="anonymous"
          src="${core.escapeHtml(overlayUrl)}"
          alt="${core.escapeHtml(state.selectedDesign.name || 'Selected Design')}"
        >
      `
      : '';

    stage.innerHTML = `
      <div class="inksoft-media-frame">
        <img
          class="inksoft-media-base"
          src="${core.escapeHtml(baseImageUrl)}"
          data-display-src="${core.escapeHtml(image.imageUrl || '')}"
          data-original-src="${core.escapeHtml(baseImageUrl)}"
          alt="${core.escapeHtml(image.label || 'Product image')}"
          width="1600"
          height="1600"
        >
        ${overlayMarkup}
      </div>
    `;

    bindOverlayFallback();
    bindMainImageZoom();
  }

  function renderThumbs() {
    const el = document.getElementById('inksoft-product-thumbs');
    if (!el) return;

    if (!state.currentImages.length) {
      el.innerHTML = '';
      return;
    }

    el.innerHTML = state.currentImages.map(function (image, index) {
      return `
        <button
          type="button"
          class="inksoft-product-thumb${index === state.currentImageIndex ? ' is-active' : ''}"
          data-image-index="${index}"
        >
          <div class="inksoft-thumb-frame">
            <img
              class="inksoft-thumb-base"
              src="${core.escapeHtml(image.thumbnailUrl || image.imageUrl)}"
              alt="${core.escapeHtml(image.label || 'Thumbnail')}"
              width="160"
              height="160"
            >
          </div>
        </button>
      `;
    }).join('');

    Array.prototype.forEach.call(el.querySelectorAll('.inksoft-product-thumb'), function (button) {
      button.addEventListener('click', function () {
        const nextIndex = Number(button.getAttribute('data-image-index'));
        state.currentImageIndex = Number.isFinite(nextIndex) ? nextIndex : 0;
        state.zoomLocked = false;
        renderMainImage();
        renderThumbs();
      });
    });
  }

  function renderSwatches(product) {
    const el = document.getElementById('inksoft-product-swatches');
    if (!el) return;

    const styles = getStyles(product);

    if (!styles.length) {
      el.innerHTML = '<div class="inksoft-product-empty">No color options available.</div>';
      return;
    }

    el.innerHTML = styles.map(function (style, index) {
      const styleId = getStyleId(style, index);
      const active = String(styleId) === String(state.currentStyleId);
      const swatchImage = normalizeInksoftUrl(asString(
        style.thumbnailUrl || style.ThumbnailUrl || style.imageUrl || style.ImageUrl ||
        product.thumbnailUrl || product.ThumbnailUrl || ''
      ));

      return `
        <button
          type="button"
          class="inksoft-product-swatch${active ? ' is-active' : ''}"
          data-style-id="${core.escapeHtml(styleId)}"
          title="${core.escapeHtml(getStyleName(style))}"
        >
          <span class="inksoft-product-swatch-inner">
            ${
              swatchImage
                ? `<img src="${core.escapeHtml(swatchImage)}" alt="${core.escapeHtml(getStyleName(style))}" width="44" height="44">`
                : '<span class="inksoft-product-swatch-fallback"></span>'
            }
          </span>
        </button>
      `;
    }).join('');

    Array.prototype.forEach.call(el.querySelectorAll('.inksoft-product-swatch'), function (button) {
      button.addEventListener('click', function () {
        const nextStyleId = button.getAttribute('data-style-id') || '';
        setCurrentStyle(nextStyleId);
      });
    });
  }

  function renderSizes(product) {
    const el = document.getElementById('inksoft-product-sizes');
    if (!el) return;

    const sizes = getSizesForStyle(getCurrentStyle(), product);

    if (!sizes.length) {
      el.innerHTML = '<div class="inksoft-product-empty">No size data available.</div>';
      return;
    }

    el.innerHTML = sizes.map(function (size) {
      return `
        <div class="inksoft-product-size">
          ${core.escapeHtml(size.name || size.Name || size.code || size.Code || 'Size')}
        </div>
      `;
    }).join('');
  }

  function bindButtons() {
    const designBtn = document.getElementById('inksoft-btn-design-online');
    const quoteBtn = document.getElementById('inksoft-btn-request-quote');
    const qtyInput = document.getElementById('inksoft-quote-qty');
    const qtyHelp = document.getElementById('inksoft-quote-qty-help');

    if (qtyInput) {
      qtyInput.min = '1';
      qtyInput.value = qtyInput.value || '1';
    }

    if (qtyHelp) {
      qtyHelp.textContent = 'Minimum order quantity: 1';
    }

    if (designBtn) {
      designBtn.onclick = function () {
        console.log('[InkSoft] DESIGN ONLINE clicked');
        launchDesignStudio({ mode: 'design' });
      };
    }

    if (quoteBtn) {
      quoteBtn.onclick = function () {
        console.log('[InkSoft] REQUEST A QUOTE clicked', {
          productId: getProductId(),
          styleId: getCurrentLaunchStyleId(),
          color: getCurrentStyle() ? getStyleName(getCurrentStyle()) : '',
          quantity: getRequestedQuantity()
        });

        openRequestQuoteForm();
      };
    }
  }

  function applySelectedDesign(design) {
    console.log('[Inksoft Product Page] Selected Design Payload', design);

    state.selectedDesign = design || null;
    state.selectedDesignConfirmedByUser = Boolean(design);
    state.selectedDesignRestoredFromUrl = false;
    state.designImageFailed = false;
    state.zoomLocked = false;

    console.log(
      '[Inksoft Product Page] Preferred Design Image URL',
      getPreferredDesignImageFromRawDesign(getRawSelectedDesign())
    );

    renderMainImage();
    clearPreparedDesignLaunch();
    /*
      Keep the blank product/style prewarm alive while the selected artwork
      mapping is prepared. It warms InkSoft resources for the first visible
      Designer launch and will be removed immediately after that launch starts.
    */
    prewarmSelectedDesignLaunch();

    const designId = getSelectedDesignId();
    if (designId) {
      setStatus('Design applied to preview successfully. Designer launch will use the correct artwork route; some custom product/color combinations may take longer.', 'success');
    } else {
      setStatus('Design applied to preview successfully, but no InkSoft design ID was found yet.', 'success');
    }

    window.scrollTo({ top: 0, behavior: 'smooth' });
  }

  function resetDesignerEmbedForStyleChange() {
    /*
      Reset the embedded InkSoft Designer whenever the customer changes color/style
      on the product page. This prevents a previous hosted Designer iframe/session
      from being reused on the next Design Now launch.
    */
    if (
      window.InksoftPOC &&
      window.InksoftPOC.designerEmbed &&
      typeof window.InksoftPOC.designerEmbed.reset === 'function'
    ) {
      window.InksoftPOC.designerEmbed.reset('product-style-change');
    }
  }

  function setCurrentStyle(styleId) {
    state.currentStyleId = String(styleId || '');

    resetDesignerEmbedForStyleChange();

    const currentStyle = getCurrentStyle();
    state.currentImages = getStyleImages(currentStyle, state.product);
    state.currentImageIndex = 0;
    state.zoomLocked = false;

    renderSwatches(state.product);
    renderSizes(state.product);
    renderMainImage();
    renderThumbs();

    if (hasLaunchableSelectedDesign()) {
      clearPreparedDesignLaunch();
      prewarmSelectedDesignLaunch();
    }

    scheduleBlankStylePrewarm('style-change');
  }

  function renderRelatedProducts(product) {
    const host = document.getElementById('inksoft-product-next-sections');
    if (!host) return;

    if (
      window.InksoftPOC &&
      window.InksoftPOC.relatedProducts &&
      typeof window.InksoftPOC.relatedProducts.render === 'function'
    ) {
      window.InksoftPOC.relatedProducts.render(host, product && product.relatedProducts ? product.relatedProducts : {});
    } else {
      host.innerHTML = '';
    }
  }

  function renderDesignIdeas() {
    const host = document.getElementById('inksoft-design-ideas-host');
    if (!host) return;

    if (
      window.InksoftPOC &&
      window.InksoftPOC.designIdeas &&
      typeof window.InksoftPOC.designIdeas.render === 'function'
    ) {
      window.InksoftPOC.designIdeas.render(host, applySelectedDesign);
    } else {
      host.innerHTML = '';
    }
  }

  function renderProduct(product) {
    ensureInksoftDesignerResourceHints();

    state.product = product;
    state.activeTab = 'description';
    state.selectedDesign = null;
    state.selectedDesignConfirmedByUser = false;
    state.selectedDesignRestoredFromUrl = false;
    state.designImageFailed = false;
    state.zoomLocked = false;
    state.lastLaunchContext = null;
    clearPreparedDesignLaunch();

    renderShell();

    const titleEl = document.getElementById('inksoft-product-title');
    if (titleEl) {
      titleEl.textContent = product.name || product.Name || 'Unnamed Product';
    }

    renderMeta(product);
    renderTabPanels(product);
    bindTabs();
    renderActiveTabState();

    const styles = getStyles(product);
    const defaultStyle = getDefaultStyle(styles);
    state.currentStyleId = getStyleId(defaultStyle, 0);

    setCurrentStyle(state.currentStyleId);
    bindButtons();
    renderDesignIdeas();
    renderRelatedProducts(product);

    /*
      Smart-share restore:
      If the URL includes styleId/designId/designImageUrl, recreate the same
      product preview state after the normal product render finishes.
    */
    applySharedStateFromUrl();
    scheduleBlankStylePrewarm('initial-product-render');
  }

  async function init() {
    await loadStorefrontDisplaySettings();

    const productId = core.qs('id');

    if (!productId) {
      setStatus('Missing product id in URL.', 'error');
      const root = getRoot();
      if (root) root.innerHTML = 'Missing product ID';
      return;
    }

    try {
      setStatus('Loading product detail...', 'info');
      const payload = await window.InksoftPOC.api.getProduct(productId);
      const product = payload && payload.data ? payload.data : payload;

      renderProduct(product);
      setStatus('Product loaded successfully.', 'success');
    } catch (err) {
      core.error('Product page init failed:', err);
      setStatus('Failed to load product detail.', 'error');

      const root = getRoot();
      if (root) root.innerHTML = 'Failed to load product';
    }
  }

  return {
    init: init,
    getState: function () {
      return state;
    },
    getCurrentStyleId: getCurrentLaunchStyleId,
    getSelectedDesignId: getSelectedDesignId,
    getLaunchContext: getLaunchContext,
    launchDesignStudio: launchDesignStudio,
    buildRequestQuoteUrl: buildRequestQuoteUrl,
    openRequestQuoteForm: openRequestQuoteForm,
    buildSmartShareUrl: buildSmartShareUrl,
    getShareData: getShareData,
    prewarmSelectedDesignLaunch: prewarmSelectedDesignLaunch,
    getPreparedLaunchForContext: getPreparedLaunchForContext
  };
})();